export default __webpack_public_path__ + "static/Oman_data_park-516e0409427467222dd50f65741c0f34.jpg";